import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
const SECRET_IV = process.env.REACT_APP_SECRET_KEY;
const IV = CryptoJS.enc.Utf8.parse(SECRET_IV as string);

const encrypt = (text: string) => {
    const encrypted = CryptoJS.AES.encrypt(text, SECRET_KEY as string, {
        iv: IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
};

const setEncryptedCookie = (key: string, value: any) => {
    localStorage.setItem(key, encrypt(typeof value === "string" ? value : JSON.stringify(value)))
    // Cookies.set(key, encrypt(typeof value === "string" ? value : JSON.stringify(value)), {
    //     path: "/",
    //     domain: isLocal ? 'localhost' : currentHost,
    //     secure: false,
    //     sameSite: 'Lax'
    // })
};

const decrypt = (cipherText: string) => {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY as string, {
        iv: IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return bytes.toString(CryptoJS.enc.Utf8);
};

const getDecryptedCookie = (key: string) => {
    const value = localStorage.getItem(key)
    // const value = Cookies.get(key);
    return value ? decrypt(value) : null;
};


const SECRET_KEY2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY2 as string); // 16-byte key
const IV2 = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_IV2 as string); // 16-byte IV

const encryptAES = (plainText: string) => {
    const encrypted = CryptoJS.AES.encrypt(plainText, SECRET_KEY2, {
        iv: IV2,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString(); // base64 string
}

const decryptAES = (encryptedText: string) => {
    const decrypted = CryptoJS.AES.decrypt(encryptedText, SECRET_KEY2, {
        iv: IV2,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}

export { encrypt, setEncryptedCookie, decrypt, getDecryptedCookie, encryptAES, decryptAES }